import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';
import { BlockContainer, Layout } from '../Layout';

export default function InPage({ code, iframeId }: Partial<IOutgrowFields>) {
  return code ? (
    <BlockContainer
      revealOnScroll={false}
      marginBottom={{ 0: 'blockMargin', tablet: 'contentMargin_tablet' }}
    >
      <Layout>
        <div
          className="max-h-[45rem] w-full"
          dangerouslySetInnerHTML={{ __html: code || '' }}
          data-testid="outgrow-inpage"
        />
        <Script
          id="outgrow-inpage"
          strategy="afterInteractive"
        >{`var og_temp=document.createElement('script');og_temp.async=true;og_temp.defer=true;og_temp.src='//dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js',og_temp.onload=function(){initIframe('${iframeId}')},document.querySelector('head').appendChild(og_temp)`}</Script>
      </Layout>
    </BlockContainer>
  ) : null;
}
